angular
  .module('picmonicng')
  .directive('plsDndContainer', [
    function () {
      return {
        restrict: 'A',
        scope: {
          plsDndItems: '=',
          plsDndItemsFilter: '@',
          plsDndDisabled: '=',
        },
        controller: [
          '$scope',
          function ($scope) {
            var self = this;

            self.items = [];
            self.placeholder = angular.element('<div class="pls-dnd-placeholder"></div>');

            $scope.$watch(
              function () {
                return $scope.plsDndItems;
              },
              function () {
                if ($scope.plsDndItemsFilter) {
                  self.items = $scope.$eval('plsDndItems | ' + $scope.plsDndItemsFilter);
                } else {
                  self.items = $scope.plsDndItems;
                }
              }
            );

            $scope.$watch(
              function () {
                return $scope.plsDndDisabled;
              },
              function () {
                self.isDisabled = $scope.plsDndDisabled;
              }
            );
          },
        ],
        link: function (scope, element, attrs) {
          element.addClass('pls-dnd-container');
        },
      };
    },
  ])
  .directive('plsDndItem', [
    '$parse',
    function ($parse) {
      return {
        restrict: 'A',
        require: '^plsDndContainer',
        scope: {
          plsDndItem: '=',
          plsDndDrop: '&',
          plsDndDisabled: '=',
          plsDndHandleClass: '@',
        },
        link: function (scope, element, attrs, plsDndContainer) {
          var container = element.parent('[pls-dnd-container]');
          var position;
          var dragged = false;

          function isDisabled() {
            return plsDndContainer.isDisabled || scope.plsDndDisabled;
          }

          // Set up directive classes and bindings
          element.addClass('pls-dnd-item');
          element.bind('tapstart', dragStartHandler);

          // Drag start event handler
          function dragStartHandler(event) {
            if (isDisabled()) return;
            if (scope.plsDndHandleClass && event.target.className.indexOf(scope.plsDndHandleClass) === -1) return;

            angular.element('body').bind('tapmove', dragHandler);
            angular.element('body').bind('tapend', dropHandler);
            plsDndContainer.placeholder.height(element.height());

            dragged = false;
            position = plsDndContainer.items.indexOf(scope.plsDndItem);
          }

          function dropHandler(event) {
            if (isDisabled()) return;
            angular.element('body').unbind('tapmove', dragHandler);
            angular.element('body').unbind('tapend', dropHandler);

            if (dragged) {
              element.removeClass('pls-dnd-item--dragging');
              container.removeClass('pls-dnd-container--dragging');
              plsDndContainer.placeholder.removeClass('pls-dnd-placeholder--dragging');

              element.css({ top: '' });

              if (typeof scope.plsDndDrop == 'function') {
                scope.$apply(function () {
                  scope.plsDndDrop({
                    $item: scope.plsDndItem,
                    $position: position,
                  });
                });
              }
            }

            dragged = false;
          }

          function dragHandler(event) {
            if (isDisabled()) return;

            var siblings = container.find('[pls-dnd-item]:not(.pls-dnd-item--dragging)');
            dragged = true;

            container.addClass('pls-dnd-container--dragging');

            element.addClass('pls-dnd-item--dragging').css({ top: element.position().top });
            element.before(plsDndContainer.placeholder);

            plsDndContainer.placeholder.addClass('pls-dnd-placeholder--dragging');
            plsDndContainer.placeholder.height(element.height());

            // Move the element the distance the mouse moved
            var newPos = event.pageY - container.offset().top - element.height() / 2;
            if (newPos < -5) {
              newPos = -5;
            } else if (newPos + element.height() > container.height() + 5) {
              newPos = container.height() - element.height() + 5;
            }

            element.css({ top: newPos });

            // Determine the element's new position amongst its siblings
            siblings.each(function () {
              var sibling = angular.element(this);
              var previousSibling = siblings.index(sibling) > 0 ? siblings.eq(siblings.index(sibling) - 1) : null;
              var nextSibling =
                siblings.index(sibling) < siblings.length - 1 ? siblings.eq(siblings.index(sibling) + 1) : null;

              if (newPos + element.height() / 2 <= sibling.position().top + sibling.height() / 2) {
                if (previousSibling) {
                  if (newPos + element.height() / 2 > previousSibling.position().top + previousSibling.height() / 2) {
                    sibling.before(plsDndContainer.placeholder);
                    position = siblings.index(sibling);
                    return false;
                  }
                } else {
                  sibling.before(plsDndContainer.placeholder);
                  position = siblings.index(sibling);
                  return false;
                }
              } else if (newPos + element.height() / 2 > sibling.position().top + sibling.height() / 2) {
                if (!nextSibling) {
                  sibling.after(plsDndContainer.placeholder);
                  position = siblings.index(sibling) + 1;
                  return false;
                }
              }
            });
          }
        },
      };
    },
  ]);
